var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2796 14.3571L30.1716 19.9905C30.9794 20.9185 32.3236 21.1234 33.3625 20.4769L36.0447 18.8103C36.3399 18.6247 36.7281 18.7195 36.9078 19.0228C36.9743 19.1329 37.0057 19.2609 36.9995 19.3902L36.164 35.2894C36.1289 35.9691 35.5774 36.5003 34.9103 36.5003H14.09C13.4216 36.5003 12.8714 35.9691 12.835 35.2894L12.0008 19.3902C11.9945 19.2609 12.0259 19.1329 12.0925 19.0228C12.2734 18.7195 12.6591 18.6247 12.9556 18.8103L15.6377 20.4769C16.6767 21.1234 18.0209 20.9185 18.8274 19.9905L23.7206 14.3571C24.1352 13.881 24.8651 13.881 25.2796 14.3571ZM24.5001 22.9648L22.2146 26.5004L24.5001 30.0359L26.7857 26.5004L24.5001 22.9648Z",
    stroke: "#F1BF70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionIcon);
export default __webpack_public_path__ + "static/media/subscriptionIcon.8c175128c8d93e219a53e2b744406497.svg";
export { ForwardRef as ReactComponent };